export default {
  link: 'Actualités',
  title: 'Actualités',
  noDetailsTitle: 'Aucun article',
  noDetailsText: 'Malheureusement, ce contenu n\'est pas disponible en français.',
};
